import { render, staticRenderFns } from "./CustomDetailInfo.vue?vue&type=template&id=8dc48798&"
import script from "./CustomDetailInfo.vue?vue&type=script&lang=ts&"
export * from "./CustomDetailInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports